import { api } from './api';
import { MenuItemDto } from '../tiposGlobais/menu';

export const menuService = {
  /**
   * Obtém o menu completo do sistema
   */
  async obterMenu(): Promise<MenuItemDto[]> {
    return await api.get<MenuItemDto[]>('/Menu');
  },

  /**
   * Obtém o menu filtrado por permissões do usuário autenticado
   */
  async obterMenuPorUsuario(): Promise<MenuItemDto[]> {
    return await api.get<MenuItemDto[]>('/Menu/usuario');
  },

};
